(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["curtain-catalog-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('curtain-catalog-navigation')) {
  customElements.define('curtain-catalog-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.cartRevision = this.cartRevision || 0;
      const bindCart = () => this.bindCartUpdates();
      bindCart();
      document.addEventListener('DOMContentLoaded', bindCart, { once: true, signal });
      window.addEventListener('load', bindCart, { once: true, signal });
      window.addEventListener('pageshow', event => { if (event.persisted) this.refreshCartCount(); }, { signal });
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') this.refreshCartCount(); }, { signal });
      this.drawer = this.querySelector('[data-ccn-drawer]');
      this.searchDialog = this.querySelector('.ccn-search-dialog');
      this.searchOpener = this.querySelector('[data-ccn-search-open]');
      this.opener = this.querySelector('[data-ccn-open]');
      this.returnFocus = true;
      this.addEventListener('click', event => {
        const open = event.target.closest('[data-ccn-open]');
        const close = event.target.closest('[data-ccn-close]');
        if (event.target.closest('[data-ccn-search-open]')) {
          this.closeDesktopMenus();
          this.searchDialog.showModal();
          this.searchOpener.setAttribute('aria-expanded', 'true');
          this.searchDialog.querySelector('input[type=search]').focus();
        }
        if (event.target.closest('[data-ccn-search-close]')) this.searchDialog.close();
        // The bag icon here used to leave the page for /cart while the main header opened the
        // drawer. Same icon, same behaviour now; the href still works without JS.
        const cartLink = event.target.closest('[data-ccn-cart-link]');
        if (cartLink) {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') { event.preventDefault(); this.closeDesktopMenus(); if (this.drawer?.open) this.drawer.close(); drawer.open(); return; }
        }
        const summary = event.target.closest('.ccn-desktop summary');
        if (summary && !event.target.closest('.ccn-summary-link')) {
          event.preventDefault();
          const item = summary.parentElement;
          const openNext = !item.open;
          this.closeDesktopMenus();
          item.open = openNext;
        }
        if (open) { this.closeDesktopMenus(); this.returnFocus = true; this.drawer.showModal(); this.opener.setAttribute('aria-expanded', 'true'); }
        if (close) this.drawer.close();
        if (event.target.closest('a,[data-ona-measure-open]')) {
          const wasInDrawer = this.drawer.contains(event.target);
          if (event.target.closest('.ccn-guide-panel [data-ona-measure-open]')) this.returnAfterDesktopMeasurement = true;
          this.querySelectorAll('details[open]').forEach(item => item.removeAttribute('open'));
          this.returnFocus = !event.target.closest('a');
          if (this.drawer.open) this.drawer.close();
          if (wasInDrawer && event.target.closest('[data-ona-measure-open]')) this.returnAfterMeasurement = true;
        }
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || this.drawer.open || this.searchDialog.open) return;
        const open = this.querySelector('.ccn-desktop details[open]');
        if (open) { open.removeAttribute('open'); open.querySelector('summary').focus(); event.preventDefault(); }
      }, { signal });
      this.querySelectorAll('.ccn-desktop details').forEach(item => {
        item.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover)').matches) return;
          clearTimeout(this.menuTimer);
          if (item.open) return;
          this.menuTimer = setTimeout(() => { this.closeDesktopMenus(); item.open = true; }, 100);
        }, { signal });
        item.addEventListener('pointerleave', () => {
          clearTimeout(this.menuTimer);
          this.menuTimer = setTimeout(() => { if (!item.contains(document.activeElement)) item.open = false; }, 160);
        }, { signal });
        item.addEventListener('focusout', event => { if (!item.contains(event.relatedTarget)) item.open = false; }, { signal });
      });
      this.searchDialog.addEventListener('close', () => { this.searchOpener.setAttribute('aria-expanded', 'false'); this.searchOpener.focus(); }, { signal });
      document.addEventListener('close', event => {
        if (!event.target.matches('dialog') || this.contains(event.target)) return;
        if (this.returnAfterDesktopMeasurement) {
          this.returnAfterDesktopMeasurement = false;
          this.querySelector('.ccn-guide-menu > summary').focus();
        } else if (this.returnAfterMeasurement) {
          this.returnAfterMeasurement = false;
          this.opener.focus();
        }
      }, { capture: true, signal });
      this.searchDialog.addEventListener('click', event => {
        if (event.target !== this.searchDialog) return;
        const rect = this.searchDialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.searchDialog.close();
      }, { signal });
      this.drawer.addEventListener('close', () => { this.opener.setAttribute('aria-expanded', 'false'); if (this.returnFocus) this.opener.focus(); }, { signal });
      this.drawer.addEventListener('click', event => {
        if (event.target !== this.drawer) return;
        const rect = this.drawer.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.drawer.close();
      }, { signal });
      document.addEventListener('click', event => { if (!this.contains(event.target)) this.querySelectorAll('.ccn-desktop details[open]').forEach(item => item.removeAttribute('open')); }, { signal });
      const updateActive = () => {
        const handle = location.hash.startsWith('#curtain-family-') ? location.hash.slice(16) : location.pathname.split('/collections/')[1]?.split('/')[0];
        this.querySelectorAll('[data-family-link]').forEach(item => item.dataset.familyLink === handle ? item.setAttribute('aria-current', 'page') : item.removeAttribute('aria-current'));
      };
      window.addEventListener('hashchange', updateActive, { signal });
      updateActive();
      const measure = this.closest('curtain-review-stage')?.querySelector('[data-measure]') || this.closest('curtain-catalog-collection')?.querySelector('[data-catalog-measure]');
      measure?.addEventListener('close', () => { if (this.returnAfterMeasurement) { this.returnAfterMeasurement = false; this.opener.focus(); } }, { signal });
    }
    closeDesktopMenus() {
      clearTimeout(this.menuTimer);
      this.querySelectorAll('.ccn-desktop details[open]').forEach(item => { item.open = false; });
    }
    bindCartUpdates() {
      if (this.cartUnsubscribe) return;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        this.cartUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => this.handleCartUpdate(event));
      }
    }
    handleCartUpdate(event) {
      const count = event?.cartData?.item_count;
      if (Number.isSafeInteger(count) && count >= 0) {
        this.cartRevision += 1;
        this.cartRequest?.abort();
        this.cartRequest = null;
        this.setCartCount(count);
        return;
      }
      return this.refreshCartCount();
    }
    setCartCount(count) {
      const known = Number.isSafeInteger(count) && count >= 0;
      this.querySelectorAll('[data-ccn-cart-link]').forEach(link => {
        const value = link.querySelector('[data-ccn-cart-count]');
        if (value) {
          value.hidden = !known || count === 0;
          value.textContent = known ? String(count) : '';
        }
        link.setAttribute('aria-label', known ? `Bag, ${count} ${count === 1 ? 'item' : 'items'}` : 'View bag');
      });
    }
    async refreshCartCount() {
      if (!this.dataset.cartJsonUrl) return;
      const revision = ++this.cartRevision;
      this.cartRequest?.abort();
      const request = new AbortController();
      this.cartRequest = request;
      this.setCartCount(null);
      try {
        const response = await fetch(this.dataset.cartJsonUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: request.signal });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (this.isConnected && revision === this.cartRevision) this.setCartCount(cart.item_count);
      } catch (_) {
        // Leave the native bag link usable; unknown count stays hidden rather than showing a stale total.
      } finally {
        if (revision === this.cartRevision) this.cartRequest = null;
      }
    }
    disconnectedCallback() {
      clearTimeout(this.menuTimer);
      this.cartUnsubscribe?.();
      this.cartUnsubscribe = null;
      this.cartRevision += 1;
      this.cartRequest?.abort();
      this.cartRequest = null;
      this.controller?.abort();
      this.controller = null;
      if (this.drawer?.open) this.drawer.close();
      if (this.searchDialog?.open) this.searchDialog.close();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["curtain-catalog-shortcuts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('curtain-catalog-shortcuts')) {
  customElements.define('curtain-catalog-shortcuts', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('[data-shortcut-track]');
      this.previous = this.querySelector('[data-shortcut-previous]');
      this.next = this.querySelector('[data-shortcut-next]');
      const update = () => {
        const end = this.track.scrollWidth - this.track.clientWidth;
        this.previous.hidden = this.next.hidden = end <= 2;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= end - 2;
      };
      this.addEventListener('click', event => {
        const backwards = event.target.closest('[data-shortcut-previous]');
        if (!backwards && !event.target.closest('[data-shortcut-next]')) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: (backwards ? -1 : 1) * this.track.clientWidth * .75, behavior: reduced ? 'auto' : 'smooth' });
      }, { signal });
      this.track.addEventListener('scroll', update, { signal, passive: true });
      window.addEventListener('resize', update, { signal });
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["curtain-fit-helper"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('curtain-fit-helper')) {
  customElements.define('curtain-fit-helper', class extends HTMLElement {
    connectedCallback() {
      if (this.cfhController) return;
      this.cfhController = new AbortController();
      this.cfhQ = selector => this.querySelector(selector);
      this.cfhText = JSON.parse(this.cfhQ('[data-cfh-copy]').textContent);
      this.cfhUnit = this.cfhQ('[data-cfh-unit]').value;
      const signal = this.cfhController.signal;
      this.addEventListener('click', event => {
        const action = event.target.closest('[data-cfh-action]');
        if (!action || !this.contains(action)) return;
        const key = action.dataset.cfhAction;
        if (key === 'build') this.buildBrief();
        if (key === 'edit') this.showFields();
        if (key === 'copy') this.copyBrief();
        if (key === 'download') this.downloadBrief();
        if (key === 'reset') this.resetFields();
      }, { signal });
      this.addEventListener('change', event => {
        const input = event.target;
        if (input.matches('[data-cfh-unknown]')) {
          const field = this.cfhQ('[data-cfh-' + input.dataset.cfhUnknown + ']');
          field.disabled = input.checked;
          if (input.checked) field.value = '';
          this.clearError(input.dataset.cfhUnknown);
        }
        if (input.matches('[data-cfh-unit]') && input.value !== this.cfhUnit) {
          this.cfhUnit = input.value;
          ['width', 'drop'].forEach(key => {
            this.cfhQ('[data-cfh-' + key + ']').value = '';
            this.clearError(key);
          });
          this.setStatus(this.cfhText.unit_changed);
        }
      }, { signal });
      this.addEventListener('input', event => {
        ['width', 'drop', 'panels'].forEach(key => {
          if (event.target.matches('[data-cfh-' + key + ']')) this.clearError(key);
        });
      }, { signal });
      this.cfhQ('[data-cfh-action="build"]').disabled = false;
    }
    disconnectedCallback() {
      if (this.cfhController) this.cfhController.abort();
      this.cfhController = null;
    }
    setStatus(text) { this.cfhQ('[data-cfh-status]').textContent = text; }
    clearError(key) {
      this.cfhQ('[data-cfh-' + key + ']').removeAttribute('aria-invalid');
      const message = this.cfhQ('[data-cfh-error="' + key + '"]');
      message.hidden = true;
      message.textContent = '';
    }
    validate() {
      let first = null;
      ['width', 'drop', 'panels'].forEach(key => {
        this.clearError(key);
        const field = this.cfhQ('[data-cfh-' + key + ']');
        const unknown = key !== 'panels' && this.cfhQ('[data-cfh-unknown="' + key + '"]').checked;
        const value = Number(field.value);
        const valid = unknown || (field.value.trim() !== '' && Number.isFinite(value) && value > 0 && (key !== 'panels' || Number.isSafeInteger(value)));
        if (!valid) {
          field.setAttribute('aria-invalid', 'true');
          const message = this.cfhQ('[data-cfh-error="' + key + '"]');
          message.textContent = this.cfhText[key + '_error'];
          message.hidden = false;
          if (!first) first = field;
        }
      });
      if (first) first.focus();
      return !first;
    }
    selected(key) {
      const field = this.cfhQ('[data-cfh-' + key + ']');
      return { value: field.value, label: field.selectedOptions[0].textContent };
    }
    oneLine(value) { return value.replace(/[\r\n\t]/g, ' ').trim(); }
    getRecord() {
      if (!this.cfhQ || !this.cfhText) return null;
      const widthRaw = this.cfhQ('[data-cfh-width]').value;
      const dropRaw = this.cfhQ('[data-cfh-drop]').value;
      const panelsRaw = this.cfhQ('[data-cfh-panels]').value;
      const widthUnknown = this.cfhQ('[data-cfh-unknown="width"]').checked;
      const dropUnknown = this.cfhQ('[data-cfh-unknown="drop"]').checked;
      const hardware = this.selected('hardware');
      const heading = this.selected('heading');
      const start = this.selected('start');
      const windowRaw = this.cfhQ('[data-cfh-window]').value;
      const notesRaw = this.cfhQ('[data-cfh-notes]').value;
      const meaningful = widthRaw || dropRaw || widthUnknown || dropUnknown || windowRaw.trim() || notesRaw.trim() || hardware.value !== 'unsure' || heading.value !== 'unsure' || start.value !== 'unsure' || panelsRaw !== '2';
      if (!meaningful) return null;
      const invalid = [];
      const number = (key, raw, unknown, integer = false) => {
        if (unknown || raw.trim() === '') return null;
        const value = Number(raw);
        if (!Number.isFinite(value) || value <= 0 || (integer && !Number.isSafeInteger(value))) { invalid.push(key); return null; }
        return value;
      };
      const width = number('width', widthRaw, widthUnknown);
      const drop = number('drop', dropRaw, dropUnknown);
      const panels = number('panels', panelsRaw, false, true);
      return { version: 1, scope: 'one_window', windowName: this.oneLine(windowRaw) || this.cfhText.blank_window, unit: this.selected('unit'), usableWidth: width, installedDrop: drop, widthText: width === null ? null : widthRaw, dropText: drop === null ? null : dropRaw, hardware, heading, dropStartPoint: start, requestedPanels: panels, notes: notesRaw.trim() || this.cfhText.notes_none, invalidFields: invalid };
    }
    recordRows(record) {
      const c = this.cfhText;
      const measure = value => value === null ? c.not_recorded : value + ' ' + record.unit.label.toLowerCase();
      return [[c.window, record.windowName], [c.width, measure(record.widthText)], [c.drop, measure(record.dropText)], [c.start, record.dropStartPoint.label], [c.hardware, record.hardware.label], [c.heading, record.heading.label], [c.panels, record.requestedPanels === null ? c.not_recorded : String(record.requestedPanels)]];
    }
    getBriefText() {
      const record = this.getRecord();
      if (!record) return '';
      const c = this.cfhText;
      const rows = this.recordRows(record);
      const correction = record.invalidFields.length ? ['', c.invalid_omitted, ...record.invalidFields.map(key => '- ' + c[key + '_error'])] : [];
      return ['# ' + c.brief_title, '', c.brief_scope, '', ...rows.map(([label, value]) => '- ' + label + ': ' + this.oneLine(value)), ...correction, '', c.notes + ':', ...record.notes.split(/\r?\n/).map(line => '> ' + line), '', '## ' + c.questions_title, '', ...[c.question_width, c.question_coverage, c.question_drop, c.question_pack, c.question_sample].map((text, index) => (index + 1) + '. ' + text), '', c.scope, ''].join('\n');
    }
    getScopeNote(mainWindows) {
      const c = this.cfhText;
      const windows = Number(mainWindows);
      const scope = Number.isInteger(windows) && windows > 1 ? c.scope_multiple.replace('{windows}', String(windows)) : c.scope_single;
      return [scope, c.scope_panels, c.scope_drop].join('\n');
    }
    buildBrief() {
      if (!this.validate()) return;
      const record = this.getRecord();
      const c = this.cfhText;
      const summary = this.cfhQ('[data-cfh-summary]');
      summary.replaceChildren();
      this.recordRows(record).forEach(([label, value]) => {
        const row = document.createElement('div');
        const title = document.createElement('dt');
        const detail = document.createElement('dd');
        title.textContent = label;
        detail.textContent = value;
        row.append(title, detail);
        summary.append(row);
      });
      const pending = [];
      if (record.usableWidth === null) pending.push(c.width_pending);
      if (record.installedDrop === null) pending.push(c.drop_pending);
      if (record.hardware.value === 'unsure' || record.hardware.value === 'not_installed') pending.push(c.hardware_pending);
      if (record.heading.value === 'unsure' || record.heading.value === 'other') pending.push(c.heading_pending);
      if (record.dropStartPoint.value === 'unsure' || record.dropStartPoint.value === 'other') pending.push(c.start_pending);
      const list = this.cfhQ('[data-cfh-pending-list]');
      list.replaceChildren();
      pending.forEach(text => { const item = document.createElement('li'); item.textContent = text; list.append(item); });
      this.cfhQ('[data-cfh-pending]').hidden = pending.length === 0;
      this.cfhQ('[data-cfh-brief]').value = this.getBriefText();
      this.cfhQ('[data-cfh-fields]').hidden = true;
      this.cfhQ('[data-cfh-review]').hidden = false;
      this.cfhQ('[data-cfh-progress]').textContent = c.step_review;
      this.setStatus(c.prepared);
      this.cfhQ('[data-cfh-review-title]').focus();
    }
    showFields() {
      this.cfhQ('[data-cfh-review]').hidden = true;
      this.cfhQ('[data-cfh-fields]').hidden = false;
      this.cfhQ('[data-cfh-progress]').textContent = this.cfhText.step_measure;
      this.cfhQ('[data-cfh-unit]').focus();
    }
    async copyBrief() {
      const brief = this.cfhQ('[data-cfh-brief]');
      try { await navigator.clipboard.writeText(brief.value); this.setStatus(this.cfhText.copied); }
      catch (_) { brief.focus(); brief.select(); this.setStatus(this.cfhText.copy_fallback); }
    }
    downloadBrief() {
      if (this.dataset.cfhDesignMode === "true" || globalThis.Shopify?.designMode) {
        this.setStatus(this.cfhText.preview_download_disabled);
        return;
      }
      let url;
      try {
        url = URL.createObjectURL(new Blob([this.cfhQ('[data-cfh-brief]').value], { type: 'text/markdown;charset=utf-8' }));
        const link = document.createElement('a');
        link.href = url;
        link.download = 'curtain-window-brief.md';
        this.append(link);
        link.click();
        link.remove();
        this.setStatus(this.cfhText.download_requested);
      } catch (_) { this.setStatus(this.cfhText.download_failed); }
      if (url) setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
    resetFields() {
      ['window', 'width', 'drop', 'notes'].forEach(key => { this.cfhQ('[data-cfh-' + key + ']').value = ''; });
      ['hardware', 'heading', 'start'].forEach(key => { this.cfhQ('[data-cfh-' + key + ']').value = 'unsure'; });
      this.cfhQ('[data-cfh-panels]').value = '2';
      this.querySelectorAll('[data-cfh-unknown]').forEach(input => { input.checked = false; this.cfhQ('[data-cfh-' + input.dataset.cfhUnknown + ']').disabled = false; });
      ['width', 'drop', 'panels'].forEach(key => this.clearError(key));
      this.cfhQ('[data-cfh-brief]').value = '';
      this.showFields();
      this.setStatus(this.cfhText.cleared);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
